import {
  SendContentType,
  SendingStatus,
  WhatsAppFileMessageType,
  WhatsAppImageMessageType,
  WhatsAppMessageType,
  WhatsAppMsgType,
  WhatsAppTextMessageType,
} from "../../types";
import {
  SendWhatsAppMessageParams,
  WhatsAppFileSendData,
  WhatsAppImageSendData,
  WhatsAppSendDataType,
  WhatsAppTextSendData,
} from "./send-message";

export const makeWhatsAppTextMsg = (
  send_message_params: Omit<
    SendWhatsAppMessageParams<WhatsAppSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WhatsAppTextSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WhatsAppMsgType.TEXT_0,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    content: send_data?.content,
  } as WhatsAppTextMessageType;
};

export const makeWhatsAppImageMsg = (
  send_message_params: Omit<
    SendWhatsAppMessageParams<WhatsAppSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WhatsAppImageSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WhatsAppMsgType.QW_IMAGE,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    file_url: send_data?.path,
    file_name: send_data?.file_name,
  } as WhatsAppImageMessageType;
};

export const makeWhatsAppFileMsg = (
  send_message_params: Omit<
    SendWhatsAppMessageParams<WhatsAppSendDataType>,
    "service_type"
  >
) => {
  const { chat_id, to_id, request_key, from_user_id, data } =
    send_message_params;
  const send_data = data?.send_data as WhatsAppFileSendData;
  return {
    chat_id,
    another_id: to_id,
    msg_server_id: "",
    msg_unique_identifier: request_key,
    msg_type: WhatsAppMsgType.QW_FILE,
    request_key,
    sender_id: from_user_id,
    timestamp: Math.floor(new Date().getTime() / 1000),
    from_user_id,
    /** 消息发送状态 */
    sending_status: SendingStatus.SENDING,
    send_message_params,
    file_name: send_data?.file_name,
    file_url: send_data?.path,
  } as WhatsAppFileMessageType;
};

export const makeWhatsAppMessage = (
  send_message_params: Omit<
    SendWhatsAppMessageParams<WhatsAppSendDataType>,
    "service_type"
  >
): WhatsAppMessageType | undefined => {
  switch (send_message_params?.data?.type) {
    case SendContentType.TEXT: {
      return makeWhatsAppTextMsg(send_message_params);
    }
    case SendContentType.IMAGE: {
      return makeWhatsAppImageMsg(send_message_params);
    }
    case SendContentType.FILE: {
      return makeWhatsAppFileMsg(send_message_params);
    }
    default:
      return;
  }
};
